@if (currentMember && currentMenu) {
    <div class="main-content">
        <div class="button-container">
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_CONTRACTS)"
                    (click)="changeTab(0)"
                    [class.selected]="tab === 0"
            >
                <span>
                    <i class="ri-file-chart-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.CONTRACTS' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_DOCS)"
                    (click)="changeTab(1)"
                    [class.selected]="tab === 1"
            >
                <span>
                    <i class="ri-file-copy-2-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.DOCS' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_TASKS)"
                    (click)="changeTab(2)"
                    [class.selected]="tab === 2"
            >
                <span>
                    <i class="ri-task-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.TASKS' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_TASKS)"
                    (click)="changeTab(3)"
                    [class.selected]="tab === 3"
            >
                <span>
                    <i class="ri-organization-chart"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.BUSINESS_PROCESS' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_FINANCE)"
                    (click)="changeTab(4)"
                    [class.selected]="tab === 4"
            >
                <span>
                    <i class="ri-wallet-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.FINANCE' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_PRODUCTION)"
                    (click)="changeTab(5)"
                    [class.selected]="tab === 5"
            >
                <span>
                    <i class="ri-shopping-cart-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.PRODUCTS' | translate }}
                </span>
            </button>
            <button class="button light"
                    *ngIf="isShowTab(TAB_ITEMS.MENU_USERS)"
                    (click)="changeTab(6)"
                    [class.selected]="tab === 6"
            >
                <span>
                    <i class="ri-door-open-line"></i>
                    {{ 'INDEX_PAGE.MAIN_TAB_TEXT.OFFICE' | translate }}
                </span>
            </button>
        </div>

        @switch (tab) {
            @case (0) {
                <app-contracts-index-tab
                        [currentMember]="currentMember"
                ></app-contracts-index-tab>
            }
            @case (1) {
                <app-documents-index-page
                        [currentMember]="currentMember"
                ></app-documents-index-page>
            }
            @case (2) {
                <app-tasks-index-tab
                        [currentMember]="currentMember"
                ></app-tasks-index-tab>
            }
            @case (3) {
                <app-business-process-index-tab
                        [currentMember]="currentMember"
                ></app-business-process-index-tab>
            }
            @case (4) {
                <app-finance-index-tab
                        [currentMember]="currentMember"
                ></app-finance-index-tab>
            }
            @case (5) {
                <app-products-index-tab
                        [currentMember]="currentMember"
                ></app-products-index-tab>
            }
            @case (6) {
                <app-office-index-tab
                        [currentMember]="currentMember"
                ></app-office-index-tab>
            }
        }
    </div>
} @else {
    <app-component-loading></app-component-loading>
}
